/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CovidMapDataTotalStats } from './covidMapDataTotalStats';

export interface CovidMapData { 
    updated_at: string;
    /**
     * serialized GeoJSON FeatureCollection
     */
    data: string;
    total_stats: CovidMapDataTotalStats;
}